import { List, Datagrid, NumberField, TextField, DateField } from 'react-admin';

export const Tbl_pianiList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <NumberField source="id" />
      <NumberField source="gruppoId" />
      <TextField source="nome" />
      <TextField source="DescrizioneCompleta" />
      <NumberField source="maxNumeroSquadre" />
      <NumberField source="maxInfografiche" />
      <NumberField source="maxPostGg" />
      <NumberField source="maxPostWeek" />
      <TextField source="imgQuality" />
      <NumberField source="Prezzo" />
      <TextField source="note" />
      <NumberField source="flVisibile" />
      <NumberField source="flAttivo" />
      <NumberField source="flAnnullato" />
      <NumberField source="ordinamento" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
